import { render, staticRenderFns } from "./DettaglioMov.vue?vue&type=template&id=5cb01efa"
import script from "./DettaglioMov.vue?vue&type=script&lang=js"
export * from "./DettaglioMov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports